import { IconSettings } from '@moovly/ui';
import { Navigate } from 'react-router-dom';
import { CurrentUserInfo } from '../../hooks/useCurrentUser';
import { BackofficeRoute } from '../../types/route.interfaces';
import FontsPage from './pages/Fonts';
import SettingsPage from './pages/Settings';
import ProfilePage from './pages/Profile';

const settingRoutes: (currentUser: CurrentUserInfo) => BackofficeRoute[] = ({
  isOrganizationAdmin,
  parentOrganizationId,
}) => {
  const children = [];
  if (isOrganizationAdmin || !parentOrganizationId) {
    children.push({
      sidebar: {
        translationKey: 'menu.brand.customization',
      },
      path: '/brand/customizations',
      element: <SettingsPage />,
    });
    children.push({
      sidebar: {
        translationKey: 'menu.brand.fonts',
      },
      path: '/brand/fonts',
      element: <FontsPage />,
    });
  }
  return [
    {
      sidebar: {
        icon: IconSettings,
        translationKey: 'menu.brand.label',
      },

      children: [
        ...children,

        {
          path: '/brand/*',
          element: <Navigate replace to={`/brand/customizations`} />,
        },
      ],
    },
    {
      path: '/settings/profile',
      element: <ProfilePage />,
    },
  ];
};

export default settingRoutes;
